/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Readd_DescInputs */



/**
* | output |
* | --- |
* | "You already paid for Compliance Copilot earlier in the billing period. Re-adding it won't incur an additional charge. It resumes on your next invoice." |
*
* @param {Sub_Addons_Confirm_Copilot_Readd_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_readd_desc = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Readd_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Readd_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben den Compliance Copilot bereits in diesem Abrechnungszeitraum bezahlt. Durch erneutes Hinzufügen entstehen keine zusätzlichen Kosten. Er wird auf Ihrer nächsten Rechnung fortgesetzt.")
	return /** @type {LocalizedString} */ ("You already paid for Compliance Copilot earlier in the billing period. Re-adding it won't incur an additional charge. It resumes on your next invoice.")
});